"use strict";
// Shared types for buildings and financial summary
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceChargeFrequency = exports.BuildingRole = void 0;
var BuildingRole;
(function (BuildingRole) {
    BuildingRole["Admin"] = "admin";
    BuildingRole["Manager"] = "manager";
    BuildingRole["Resident"] = "resident";
    BuildingRole["Viewer"] = "viewer";
})(BuildingRole = exports.BuildingRole || (exports.BuildingRole = {}));
var ServiceChargeFrequency;
(function (ServiceChargeFrequency) {
    ServiceChargeFrequency["Monthly"] = "monthly";
    ServiceChargeFrequency["Quarterly"] = "quarterly";
    ServiceChargeFrequency["Annually"] = "annually";
})(ServiceChargeFrequency = exports.ServiceChargeFrequency || (exports.ServiceChargeFrequency = {}));
